<template>
  <div class="current-balance">
    <div class="notification is-danger" v-if="showError">
      An error was encountered trying to retrieve your balance. Please
      check your network connection and try again.
    </div>
    <h2 v-else>${{ balance.toFixed(2) }}</h2>
  </div>
</template>

<script>
import accountService from "../services/AccountService";

export default {
  name: "current-balance",
  data() {
    return {
      showError: false,
    };
  },
  computed: {
    balance() {
      return this.$store.state.balance;
    },
  },
  mounted() {
    accountService
      .getBalance()
      .then((response) => {
        this.$store.commit("SET_BALANCE", response.data.balance);
      })
      .catch((error) => {
        if(error.response.status === 401){
          // log them out.
          this.$router.push("/logout");
        } else {
          this.showError = true;
        }
      });
  },
};
</script>

<style>
</style>